import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { useScrollDirection } from 'ziphy-web-shared/basic/hooks';
import Toolbar from '@nedoShared/features/layouts/toolbar/Toolbar';
import { $calendar } from '../Calendar.store';
import TableHeader from '../table/tableHeader/TableHeader';
import Header from './header/Header';
import styles from './StickyHeader.module.scss';
const StickyHeader = ({ isLoading }) => {
    const { scrollDirection } = useScrollDirection({ distanceUp: 100 });
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, { hasBurger: $calendar.isMobile, className: classNames(styles.toolbar, $calendar.isMobile && styles.isMobile, scrollDirection === 'down' && styles.down), useScroll: false }), _jsxs("div", Object.assign({ className: classNames(styles.stickyHeader, $calendar.isMobile && styles.isMobile, scrollDirection === 'down' && styles.down) }, { children: [_jsx(Header, { isLoading: isLoading, className: styles.header }), _jsx(TableHeader, { isLoading: isLoading, className: styles.tableHeader })] }))] }));
};
export default observer(StickyHeader);
